<template>
  <div class="table-empresas-container">
    <Table :datas="empresas" :height="400" stripe border>
        <TableItem title="Nome" prop="nome" :width="150" />
        <TableItem title="CNPJ" prop="cnpj" :width="150" />
        <TableItem title="Código PDV" prop="codigoPDV" :width="150" />
        <TableItem title="Tipo de Operação" prop="operacao" :render="formatOperacao"  :width="150" />
        <TableItem :width="50">
          <template slot-scope="{data}">
          <button class="h-btn h-btn-s h-btn-blue" @click="handleOpenModal(data)">
            <i class="h-icon-edit"></i>
          </button></template>
        </TableItem>
    </Table>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('empresas');
export default {
  name: 'Tableempresas',
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      empresas: state => state.empresas
    })
  },
  methods: {
    ...mapMutations(['handleOpenModalEmpresas', 'setValuesToEdit']),
    handleOpenModal(value) {
      this.setValuesToEdit(value);
      this.handleOpenModalEmpresas(true);
    },
    formatOperacao(value) {
      return value.operacao === 'VD'
        ? 'Venda Direta'
        : value.operacao;
    }
  }
};
</script>
<style scoped>
.table-empresas-container{
margin: 24px;
}
</style>
